import { useEffect, useState } from 'react';
import { language, subscribeLanguage, type Language } from './i18n.js';

/**
 * Re-render on a language change. The dictionary lookup itself is a plain function
 * call (`t`), not a hook — a component only needs to KNOW when to re-render, and
 * threading a translate function through context would make every screen import a
 * provider to do what a module-level function already does.
 *
 * Same shape as `subscribeRoute`: subscribe, fire immediately, unsubscribe on unmount.
 */
export function useLanguage(): Language {
  const [current, setCurrent] = useState<Language>(() => language());
  useEffect(() => subscribeLanguage(setCurrent), []);
  return current;
}
